import { render, staticRenderFns } from "./MxModal.vue?vue&type=template&id=319d728a"
import script from "./MxModal.vue?vue&type=script&lang=ts"
export * from "./MxModal.vue?vue&type=script&lang=ts"
import style0 from "./MxModal.vue?vue&type=style&index=0&id=319d728a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports